import * as types from './actionTypes';

// fetch Surveys
export function fetchSurveys() {
  return {
    type: types.FETCH_SURVEYS_REQUEST,
  };
}

export function fetchSurveysSuccess({ data }) {
  return {
    type: types.FETCH_SURVEYS_SUCCESS,
    data,
  };
}

export function fetchSurveysFail({ error }) {
  return {
    type: types.FETCH_SURVEYS_FAIL,
    error,
  };
}

// fetch Survey
// export function fetchSurvey({ id }) {
//   return {
//     type: types.FETCH_SURVEY_REQUEST,
//     id,
//   };
// }

// export function fetchSurveySuccess({ data, id }) {
//   return {
//     type: types.FETCH_SURVEY_SUCCESS,
//     data,
//     id,
//   };
// }

// export function fetchSurveyFail({ error, id }) {
//   return {
//     type: types.FETCH_SURVEY_FAIL,
//     error,
//     id,
//   };
// }
// submit Survey Form
export function submitSurveyForm({ id, idPart, payload }) {
  return {
    type: types.SUBMIT_SURVEY_FORM_REQUEST,
    id,
    idPart,
    payload,
  };
}

export function submitSurveyFormSuccess({ data, id, idPart, commercialProducts }) {
  return {
    type: types.SUBMIT_SURVEY_FORM_SUCCESS,
    data,
    id,
    idPart,
    commercialProducts,
  };
}

export function submitSurveyFormFail({ error, id, idPart }) {
  return {
    type: types.SUBMIT_SURVEY_FORM_FAIL,
    error,
    id,
    idPart,
  };
}
